import { RevealMask } from "@/components/motion/Reveal";
import ScrambleText from "@/components/motion/ScrambleText";
import { testimonials } from "@/data/content";

export default function Testimonials() {
  return (
    <section data-testid="testimonials" className="border-t border-line bg-bone">
      <div className="mx-auto max-w-[1600px] px-5 py-20 sm:py-24 md:py-28 lg:py-36 xl:py-40 sm:px-8 md:px-10 lg:px-12 xl:px-16">
        <ScrambleText as="p" text="In their words" className="mb-4 block text-xs font-bold uppercase tracking-[0.22em] text-accent" />
        <RevealMask as="h2" className="font-display text-5xl font-extrabold leading-[0.95] tracking-tight text-ink md:text-7xl">
          Client testimonials
        </RevealMask>

        {testimonials.length === 0 ? (
          <div className="mt-10 max-w-2xl border border-dashed sm:mt-12 border-accent/40 bg-surface p-8">
            <p className="text-lg text-muted">
              Verified client testimonials will appear here. We will only publish quotes we can attribute and confirm — no invented praise.
            </p>
          </div>
        ) : (
          <>
            <div className="mt-10 grid gap-6 sm:mt-12 sm:gap-8 md:grid-cols-2" data-testid="testimonials-grid">
              {testimonials.map((t, i) => (
                <blockquote key={i} data-testid={`testimonial-${i}`} className="border-t border-line pt-8">
                  <p className="font-serif text-2xl italic leading-snug text-ink md:text-3xl">&ldquo;{t.quote}&rdquo;</p>
                  <footer className="mt-6 text-sm font-bold uppercase tracking-[0.14em] text-muted">
                    {t.name}, {t.company}
                  </footer>
                </blockquote>
              ))}
            </div>
          </>
        )}
      </div>
    </section>
  );
}
